import { render, staticRenderFns } from "./ThirdParty.vue?vue&type=template&id=61d51196&scoped=true&"
import script from "./ThirdParty.vue?vue&type=script&lang=js&"
export * from "./ThirdParty.vue?vue&type=script&lang=js&"
import style0 from "./ThirdParty.vue?vue&type=style&index=0&id=61d51196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d51196",
  null
  
)

export default component.exports